export const categories = [
  'Sell',
  'Lost/found',
  'In good hands',
  'Favorite ads',
  'My ads',
];

export const categoriesWithoutAuth = ['Sell', 'Lost/found', 'In good hands'];

export const daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const requestCategories = {
  sell: '?category=sell',
  'lost-found': '?category=lost-found',
  'in-good-hands': '?category=in-good-hands',
  'favorite-ads': '/favorites?',
  'my-ads': '/private?',
};
